import { isFeatureEnabled } from '@sdk/utils/isFeatureEnabled';

import config from '@angular/config';
import rosterActionsUrl from '@angular/roster/components/rosterActionsComponent.html';

class RosterActionsCtrl {
  constructor(
    Authentication,
    EventCollection,
    TimesheetsUtils,
    TimesheetsService,
    ShiftUtils,
    AbsenceUtils,
    extendShiftModel,
    sdk
  ) {
    'ngInject';

    const { NO_SHOW_TYPE, SICK_CALLOUT_TYPE } = sdk('constants');
    Object.assign(this, {
      Authentication,
      EventCollection,
      TimesheetsUtils,
      TimesheetsService,
      ShiftUtils,
      AbsenceUtils,
      extendShiftModel,
      NO_SHOW_TYPE,
      SICK_CALLOUT_TYPE,
    });
  }

  $onInit() {
    this.REDESIGNED_CLOCK_IN_MODAL_ENABLED = isFeatureEnabled(
      config.REDESIGNED_CLOCK_IN_MODAL_ENABLED,
      this.Authentication.user.org.id
    );
    this.isTimesheetEditActive = false;
    this.timesheetEditShift = null;
  }

  get clockInEnabled() {
    return this.Authentication.user.orgSettings.clockInEnabled;
  }

  canEditTimesheet() {
    return (
      !this.AbsenceUtils.isAbsenceEvent(this.event) &&
      this.TimesheetsUtils.canEditTimesheet(this.event)
    );
  }

  canEditEvent() {
    return this.Authentication.user.canActOnLocation(this.event.location);
  }

  async markAsNoShow() {
    const data = await this.AbsenceUtils.markAsNoShow(this.event);
    if (data) {
      this.refresh();
    }
  }

  async markAsSickCallout() {
    const data = await this.AbsenceUtils.markAsSickCallout(this.event);
    if (data) {
      this.refresh();
    }
  }

  updateRosterEvent(event) {
    if (event) {
      this.updateEvent({ event });
    }
  }

  async editTimesheet() {
    if (this.REDESIGNED_CLOCK_IN_MODAL_ENABLED) {
      await this.ediTimesheetV2();
    } else {
      try {
        const updatedEvent = await this.TimesheetsService.viewTimesheet({
          event: this.event,
        });
        this.updateRosterEvent(updatedEvent);
      } catch {
        //
      }
    }
  }

  async ediTimesheetV2() {
    this.isTimesheetEditActive = true;
    try {
      const timesheet = await this.EventCollection.getEvent(this.event.id, {
        includeTimesheets: 'full',
      });
      this.timesheetEditShift = this.extendShiftModel(timesheet);
    } catch {
      //
    }
  }

  closeTimesheetEdit() {
    this.isTimesheetEditActive = false;
    this.timesheetEditShift = null;
  }

  async onEditTimesheet(shiftId) {
    try {
      await this.onTimesheetSave(shiftId);
      this.closeTimesheetEdit();
    } catch {
      //
    }
  }

  async onTimesheetSave(shiftId) {
    const event = await this.EventCollection.getEvent(shiftId, { includeTimesheets: 'full' });
    const extendedEvent = this.TimesheetsService.extendTimesheetModel(event);
    this.updateRosterEvent(extendedEvent);
  }

  async deleteShift() {
    const updatedEvents = await this.ShiftUtils.deleteShift(this.event);
    this.updateRosterEvent(updatedEvents[0]);
  }
}

export default {
  templateUrl: rosterActionsUrl,
  controller: RosterActionsCtrl,
  controllerAs: 'ctrl',
  bindings: {
    event: '<',
    updateEvent: '&',
    refresh: '&',
  },
};
